'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import CampaignDetailsTableContainer from 'AdsUI/containers/campaign-details/CampaignDetailsTableContainer';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import { EntityTypes } from 'AdsUI/lib/Constants';
const SequenceCampaignDetailsBreadcrumb = withRouter(({
  parent,
  entityType,
  history,
  match: {
    params: {
      network,
      accountId,
      campaignId,
      sequenceId
    }
  },
  location
}) => {
  const handleReturnToCampaigns = useCallback(() => {
    const query = new URLSearchParams(location.search);
    history.push({
      pathname: `/sequences/${sequenceId}`,
      query
    });
  }, [location, sequenceId, history]);
  const handleReturnToAdSets = useCallback(() => {
    const query = new URLSearchParams(location.search);
    history.push({
      pathname: `/sequences/${sequenceId}/accounts/${network}/${accountId}/campaigns/${campaignId}`,
      query
    });
  }, [location, history, network, sequenceId, accountId, campaignId]);
  return /*#__PURE__*/_jsxs(UIBreadcrumbs, {
    className: "p-left-0",
    singleBreadcrumbIsBackLink: false,
    children: [/*#__PURE__*/_jsx(UILink, {
      onClick: handleReturnToCampaigns,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sequenceDetails.backToCampaigns"
      })
    }), entityType === EntityTypes.AD ? /*#__PURE__*/_jsx(UILink, {
      onClick: handleReturnToAdSets,
      children: /*#__PURE__*/_jsx("span", {
        children: parent && parent.name
      })
    }) : /*#__PURE__*/_jsx("span", {
      children: parent && parent.name
    })]
  });
});

class SequenceCampaignDetailsPage extends PureComponent {
  render() {
    const {
      loading
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CampaignDetailsTableContainer, {
        CampaignDetailsBreadcrumbComponent: SequenceCampaignDetailsBreadcrumb
      }), !loading && /*#__PURE__*/_jsx(NavMarker, {
        name: "CAMPAIGN_DETAILS_LOADED"
      })]
    });
  }

}

SequenceCampaignDetailsPage.propTypes = {
  loading: PropTypes.bool.isRequired
};
export default SequenceCampaignDetailsPage;